// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"43ff8137","291":"c778a43d","293":"ea374591","401":"eee729c1","833":"2a5dd1ce","895":"3aed89f9"}[chunkId] + ".chunk.js";
};